export default __webpack_public_path__ + "static/media/team.870b13fc.JPG";